// Deploy marker: re-announce staging QA tickets (cap 100, Slack block-split fix).
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import './index.css';
import App from './app';
import router from './router';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    {/* <React.StrictMode> */}
    <App>
      <RouterProvider router={router} />
    </App>
    {/* </React.StrictMode> */}
  </>,
);
